var map = {
	"./10step-02-04-1-1_ergebnis.png": "6034",
	"./10step-02-04-1_ergebnis.png": "b352",
	"./11step-02-05-1_ergebnis.png": "bff3",
	"./12step-02-06-1_ergebnis.png": "0cb4",
	"./13step-03-01-1_ergebnis.png": "aeab",
	"./13step-03-02-1_ergebnis.png": "761c",
	"./13step-03-03-1_ergebnis.png": "e811",
	"./13step-04-1_ergebnis.png": "504a",
	"./1intro-1_ergebnis.png": "c991",
	"./20210625_Teilkauf_2849.png": "9e8e",
	"./20210625_Teilkauf_2850.png": "fb07",
	"./20210625_Teilkauf_2893.png": "1085",
	"./20210625_Teilkauf_2897.png": "6325",
	"./20210625_Teilkauf_2926.png": "118b",
	"./2step-01-01-1_ergebnis.png": "621b",
	"./4step-01-03-1_ergebnis.png": "1e70",
	"./5-error-1_ergebnis.png": "139a",
	"./6solved-1_ergebnis.png": "3efb",
	"./7step-02-01-1_ergebnis.png": "f2dc",
	"./8step-02-02-1_ergebnis.png": "38b0",
	"./9step-02-03-1-1_ergebnis.png": "10f8",
	"./9step-02-03-1_ergebnis.png": "b7ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";